import { Store } from 'pullstate'

// GlobalRefetchStore
export default new Store({

  // Basket count fetch key
  basketCountFetchKey: new Date(),
  bestServicesKey: new Date()

})